import { render, staticRenderFns } from "./StageAssignmentRejected.vue?vue&type=template&id=6e23f3ae&"
import script from "./StageAssignmentRejected.vue?vue&type=script&lang=ts&"
export * from "./StageAssignmentRejected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports